// Module
var code = `<p> <label> <input name="{{ inputName }}" type="radio" ng-model="inputModel" ng-value="inputValue" ng-change="inputChange" ng-click="inputClick"/> <span class="ml-2" translate>{{ inputLabel }}</span> </label> </p> `;
// Exports
export default code;